var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container skokka-carousel" },
    [
      _vm.numberOfSlides > 1
        ? _c("skokka-carousel-controls", {
            on: { click: _vm.handleOnControlClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "track",
          staticClass: "carousel-track",
          class: _vm.trackClassName,
          on: { scroll: _vm.handleOnTrackScroll },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }